<template>
    <div id="language_selector">
        <div>{{ $t('Language') }}</div>
        <cic-select
            id="login_lang"
            :value="$i18n.locale"
            :options="
                languages
                    .filter((x) => x.value === $i18n.locale)
                    .concat(languages.filter((x) => x.value !== $i18n.locale))
                    .map((option) => ({ ...option, icon: `${option.value}-flag` }))
            "
            popper-class="languageSelectPopper"
            @input="setLocale"
        />
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';
    import { languages, setLocale } from '@/i18n';

    export default {
        name: 'LanguageSelector',
        components: {
            CicSelect,
        },
        data() {
            return {
                languages,
            };
        },
        methods: {
            setLocale,
        },
    };
</script>
